import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, cx } from 'react-emotion';
import { Wrapper, Left, Middle, Right, wrapperAktualne } from './Symbols/WidgetLayout';
import WidgetList from './Components/WidgetList';
import { Button } from './Components/InterestingDistricts/styles';
import { sortBy } from './Utils/Sorters';
import Map from './Components/Map/Regional'
import { getHasFirstRoundStarted, getHasElectionStarted, getHasElectionFinished } from './Utils/Getters';
import { percentFormat } from './Utils/NumberFormatting';
import InfoPanel from './Components/InfoPanel/SenateRegion';
import withDataLoader from './Utils/withDataLoader';
import styles, { regionalMap } from './Components/Map/styles';

const WrapperAktualneRegionalSenate = styled(Wrapper)`
	@media (max-width: 759px) {
		flex-wrap: wrap-reverse
	}
`;

const RegionalTopMdButton = styled.div`
	float: right;
	
	a {
		margin-top: 0px;
	}
	
	@media (max-width: 479px) {
		display: none;
	}
`;


const RegionalBottomSmButton = styled.div`
	text-align: center;
	width: 100%;
	
	@media (min-width: 480px) {
		display: none;
	}
`;

const senateLeft = css`
	div {
		text-align: center;
	}
	@media (max-width: 759px) {
		flex-basis: 100%;
		display: unset;
	}
`;

const regionalMiddle = css`
	svg {
		max-height: 170px;
	}
`;

const senateLeftTitle = css`
	color: #fff;
	@media (max-width: 759px) {
		margin-bottom: 0;
	}
`;

const VerticalCenter = styled.div`
	@media (min-width: 760px) {
		margin-top: 3.125rem; 
	}
	@media (max-width: 759px) {
		margin: 1rem
	}
`;

const WidgetTitle = styled.div`
	font-size: 1.5rem;
	font-weight: bold;
	margin-bottom: 1rem;
	text-align: left;

	@media (max-width: 480px) {
		text-align: center;
	}
`;

const Subtitle = styled.div`
	font-size: 1.125rem;
	font-weight: bold;
	margin-bottom: 0.5rem;
	@media (max-width: 759px) {
		font-size: 16px
	}
`;

const SubtitleSenate = styled(Subtitle)`
	color: #fff;
`

const SpaceBetween = css`
	@media (min-width: 480px) {
		align-items: center;
		display: flex;
		justify-content: space-between;
	}
`;

const NoMargin = css`
	@media (max-width: 759px) {
		margin: 0;
	}
`

const Percent = styled.span`
	white-space: nowrap;
`
const Turnout = styled.div`
	margin-left: 1rem;
	text-align: center;
`

class App extends React.PureComponent {
	state = {
		interestingDistricts: [],
		finalists: [],
		regionalData: null,
		senateData: null
	};

	componentDidMount() {
		this.load();
	}

	componentDidUpdate() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	load = () => {
		this.props.loadDataAsync(
			[`regional/${this.props.year}/vysledky_full.json`, `senate/${this.props.year}/vysledky_full.json`]
		).then(
			([regionalData, senateData]) => {
				// const finalistCandidates = Object.values(senateData.body.candidates)
				// 	.filter(candidate => senateData.body.finalists.includes(candidate.id))
				// 	.sort(sortBy(1, 'votes'));

				this.setState({
					...this.state,
					regionalData: regionalData.body,
					senateData: senateData.body
					// interestingDistricts: (this.props.interestingDistricts || this.props.districts.slice(0, 3)).map(district => {
					// 	return {
					// 		...(senateData.body.leaders[0][district] || {}).area,
					// 		names: finalistCandidates.filter(finalist => finalist.area.id === district).map(finalist => finalist.lastName)
					// 	};
					// }),
					// finalistCandidates
				})
			}).catch(console.error);
	}
	clickRegion = (id) => {
		window.top.location.href = this.props.linkToRegional + `#/kraj/${id}`
	};

	render() {
		if (!this.state.regionalData || !this.state.senateData) {
			return null;
		}
		const hasSenateFirstRoundStarted = getHasFirstRoundStarted(this.state.senateData.meta[0]);
		const hasSenateFirstRoundFinished = getHasElectionFinished(this.state.senateData.meta[0]);
		const hasRegionalElectionStarted = getHasElectionStarted(this.state.regionalData.meta);
		const hasRegionalElectionFinished = getHasElectionFinished(this.state.regionalData.meta);
		const hasElectionFinished = hasRegionalElectionFinished && hasSenateFirstRoundFinished;

		return (
		<>
			<WrapperAktualneRegionalSenate className={wrapperAktualne}>
				<Left className={senateLeft}>
					<WidgetTitle className={senateLeftTitle}>Senátní volby</WidgetTitle>
					<VerticalCenter>
						{hasSenateFirstRoundStarted ?
							(
								<>
									<SubtitleSenate>Volební účast: <Percent>{percentFormat(this.state.senateData.meta[0].turnout, 2)}</Percent></SubtitleSenate>
									<SubtitleSenate>Sečteno: <Percent>{percentFormat(this.state.senateData.meta[0].count, 2)}</Percent></SubtitleSenate>
								</>
							)
							:
							(
								<SubtitleSenate>Podívejte se, kdo kandiduje ve vašem obvodu.</SubtitleSenate>
							)
						}
					</VerticalCenter>
					<Button className={NoMargin} href={this.props.linkToSenate}>
							Přehled všech obvodů
					</Button>

				</Left>
				<Middle className={regionalMiddle}>
					<WidgetTitle>
						Krajské volby
						<RegionalTopMdButton>
							<Button reverse href={this.props.linkToRegional}>
								Přehled všech obvodů
							</Button>
						</RegionalTopMdButton>
					</WidgetTitle>
					<div className={hasRegionalElectionStarted ? SpaceBetween : ''}>
						<Map regions={this.state.regionalData.regions} meta={this.state.regionalData.meta} onClick={this.clickRegion} />
						{hasRegionalElectionStarted &&
						<Turnout>
							<Subtitle>Volební účast: <Percent>{percentFormat(this.state.regionalData.meta.turnout, 2)}</Percent></Subtitle>
							<Subtitle>Sečteno: <Percent>{percentFormat(this.state.regionalData.meta.count, 2)}</Percent></Subtitle>
						</Turnout>
						}
					</div>
					<RegionalBottomSmButton>
						<Button className={NoMargin} reverse href={this.props.linkToRegional}>
							Přehled všech obvodů
						</Button>
					</RegionalBottomSmButton>
				</Middle>
				<Right>
					<WidgetList articles={this.props.articles} />
				</Right>
			</WrapperAktualneRegionalSenate>
			{hasSenateFirstRoundStarted && hasRegionalElectionStarted && !hasElectionFinished &&
			<InfoPanel
				linkToRegional={this.props.linkToRegional}
				linkToSenate={this.props.linkToSenate}
				candidates={this.state.senateData.candidates}
				districts={this.state.senateData.districts}
				regions={this.state.regionalData.regions}
				roundIndex={0}
			/>
			}
		</>
		)
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	linkToSenate: PropTypes.string.isRequired,
	linkToRegional: PropTypes.string.isRequired,
	articles: PropTypes.arrayOf(PropTypes.object),
	interestingDistricts: PropTypes.arrayOf(PropTypes.number),
	onUpdate: PropTypes.func
};

App.defaultProps = {
	linkToSenate: 'senate-2020.html',
	linkToRegional: 'regional-2020.html'
};

export default withDataLoader(App)
